module.exports = {
	"basic": {
		"title": "Title",
		"items": [
			{
				"id": 0,
				"description": "Description"
			}
		]
	},
	"timerange": {
		"title": "Title",
		"items": [
			{
				"id": 0,
				"title": "Name",
				"description": "Description",
				"timerange": "09.2016-02.2017"
			}
		]
	},
	"skills": {
		"title": "Title",
		"items": [
			{
				"id": 0,
				"title": "Name",
				"percent": 80
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/data/defaultSectionsModel.json
// module id = 149
// module chunks = 0